import { useAppSelector } from '../index';

export const useLocaleSelector = () => useAppSelector((state) => state.locale);
